import React, { useEffect, useState, useRef } from "react";
import { H2, MKDiv } from "../commonStyle";
import CountUp from "react-countup";
import VisibilitySensor from "react-visibility-sensor";
import { DME } from "dmeditor";
import { EntityClubMembers } from "./entity";
import { siteEnv } from "../siteEnv";

const ClubMembers = (props: DME.WidgetRenderProps<EntityClubMembers>) => {
  const {
    blockNode: { data },
  } = props;

  const [medlemmerKlubbenList, setMedlemmerKlubbenList] = useState(() => {
    if (data.value) {
      return data.value;
    } else {
      return [
        { type: "Antall", value: 0 },
        { type: "Std", value: 0 },
        { type: "Jr", value: 0 },
        { type: "I", value: 0 },
        { type: "Lisens", value: 0 },
      ];
    }
  });

  const [focus, setFocus] = useState(false);

  useEffect(() => {
    if (!props.blockNode.serverData) {
      // fetchData(siteEnv).then((newContent) => {
      //   setMedlemmerKlubbenList(newContent || []);
      // });
    }
  }, []);

  return (
    <>
      <MKDiv className={"medlemmerKlubben"}>
        <H2 white={true}>{data.title}</H2>
        <div className="medlemmerKlubben-body">
          {medlemmerKlubbenList.map((item: any, index: any) => {
            return (
              item.value > 0 && (
                <React.Fragment key={index}>
                  <div className="medlemmerKlubben-group">
                    <div className="item-v">
                      {props.mode === "edit" && item.value}
                      {props.mode === "view" && (
                        <CountUp
                          start={focus ? 0 : undefined}
                          end={item.value || 0}
                          duration={1}
                        >
                          {({ countUpRef }) => (
                            <VisibilitySensor
                              partialVisibility
                              offset={{ bottom: 50 }}
                              onChange={(isVisible) => {
                                if (isVisible) {
                                  setFocus(true);
                                }
                              }}
                            >
                              <span ref={countUpRef} />
                            </VisibilitySensor>
                          )}
                        </CountUp>
                      )}
                    </div>

                    <div className="item-t">{item.type}</div>
                  </div>
                </React.Fragment>
              )
            );
          })}
        </div>
      </MKDiv>
    </>
  );
};

export { ClubMembers };
